module.exports = __webpack_public_path__ + "static/TTNRegular-4c78e322132e35b5666870a153e4f2e2.woff";